'use strict';

export default function($window, pusher) {
  'ngInject';

	return {
		scope: {
      userId: '<',
      assumedEntityId: '<',
			autoRefresh: '<',
		},
    transclude: true,
		template: '<div ng-transclude></div>',
    require: '^ngModel',
		link: function(scope, _element, _attrs, ngModelCtrl) {
      const state = {
        hasChanged: false,
      };
  		ngModelCtrl.$setViewValue(state);
      if (!scope.userId) {
        console.error('User ID is required');
        return;
      }
      const channel = pusher.subscribe(`presence-user-${scope.userId}`);
      channel.$bind('entity_switched', (data) => {
        console.log('User switched entities', data)
        state.hasChanged = data.entity_id !== scope.assumedEntityId;
        if (state.hasChanged && scope.autoRefresh) {
          $window.location.reload();
        }
      });
		},
	};
}
